export const LOAD_ALL_THREADS = "LOAD_ALL_THREADS";
export const LOAD_ALL_THREADS_FAILED = "LOAD_ALL_THREADS_FAILED";
export const LOAD_ALL_THREADS_REQUEST = "LOAD_ALL_THREADS_REQUEST";
export const DELETE_THREAD = "DELETE_THREAD";
export const GET_FORUM = "GET_FORUM";
export const GET_COMMENT = "GET_COMMENT"
export const LOAD_ALL_THREADS_BY_ORDER = "LOAD_ALL_THREADS_BY_ORDER";
export const ADD_THREAD = "ADD_THREAD";
export const EDIT_THREAD = "EDIT_THREAD";
export const ADD_COMMENT = "ADD_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const UPVOTE_COMMENT = "UPVOTE_COMMENT";
export const LOAD_ALL_REPLIES = "LOAD_ALL_REPLIES";
export const PIN_CONTENT = "PIN_CONTENT";
export const MARK_IMPORTANT = "MARK_IMPORTANT";
export const UPVOTE_THREAD = "UPVOTE_THREAD";
export const ADD_REPLY = "ADD_REPLY";
export const EDIT_REPLY = "EDIT_REPLY";
export const DELETE_REPLY = "DELETE_REPLY";
export const UPVOTE_REPLY = "UPVOTE_REPLY";
export const PIN_THREAD_CONTENT = "PIN_THREAD_CONTENT";
export const PIN_COMMENT_CONTENT = "PIN_COMMENT_CONTENT";
export const CHANGE_THREAD_TAGS = "CHANGE_THREAD_TAGS";
export const PIN_REPLY_CONTENT = "PIN_REPLY_CONTENT";